import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { textSearchParams } from '@@containers/Search/unitySearchParams';
import { requireRoles } from '@@router/guards';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { Layout } from './-components/Layout';
import { tagListQuery } from './-components/tagListQuery';

const requireTagRoles = requireRoles(config.navigation.tags.authorize);

export const Route = createFileRoute('/_authenticated/tags')({
    validateSearch: textSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => textSearchParams.parse(search),
    beforeLoad: ({ search }) => {
        requireTagRoles();

        const contentLocale = getContentLocale();

        // Built on every load, so the options follow the content language as well as the search
        return {
            activeTagsQuery: tagListQuery({ q: search.q, active: true }, contentLocale),
            allTagsQuery: tagListQuery({ q: search.q }, contentLocale),
        };
    },
    // Both tabs' queries run, for their counts
    loader: ({ context }) => {
        context.queryClient.infiniteQuery(context.activeTagsQuery).catch(doNothing());
        context.queryClient.infiniteQuery(context.allTagsQuery).catch(doNothing());
    },
    component: Layout,
});
